export const TEAM_COLORS = ['danger', 'primary', 'success', 'warning', 'info', 'secondary'];